module.exports = __webpack_public_path__ + "img/sintesis.7cd75143.svg";